import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class ChatService {
  url = environment.urlWhats;
  urlWha = environment.urlWha;
  // urlMasivos = environment.urlMasivos;
  urlWs = environment.urlWhatsWs;
  urlStorage = environment.storageUrl;
  urlMasivos = environment.urlWhatsMasivos;

  urlConsultaTexto = 'https://barbering.iatich.de/openai/api/';

  constructor(
    public wsService: SocketService,
    private http: HttpClient
  ) { }



  sendMessage(mensaje: string, de) {

    const payload = {
      de,
      cuerpo: mensaje
    };

    this.wsService.emit('mensaje', payload);

  }

  //consultar cliente asignado a agente
  // consultarNumeroCliente(idAdmin, data){
  //   return this.http.post(`${this.url}consultarIdSocketAgente/${idAdmin}`, data);
  // }

  consultarNumerosAgente(idAdmin, idAgente, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getNumeros/${idAgente}/${idAdmin}/${id}/${role}`, { headers });
  }

  consultarSedes(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/sedes/${idAdmin}/${id}/${role}`, { headers });
  }

  getInfoAgenteCanales(usuario, idAdmin, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/getInfoAgente/${usuario}/${idAdmin}/${id}/${role}`, { headers });
  }

  enviarWhatsapp(url, data, id, role, token) {
    data.url = url;
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //return this.http.post(`${url}send.php/`, data);
    return this.http.post(`${this.url}/send/${id}/${role}`, data, { headers });
  }

  cierreForzado(idSocket, data) {
    const headers = new HttpHeaders()
    //return this.http.post(`${url}send.php/`, data);
    return this.http.post(`${this.urlWha}cierreSesion/${idSocket}/`, data, { headers });
  }

  enviarWhatsappBd(data, id, role, token, urlBack) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    //return this.http.post(`${url}send.php/`, data);
    return this.http.post(`${urlBack}/sendCompleto/${id}/${role}`, data, { headers });
  }

  // messenger facebook

  enviarMensajeFacebookMessenger(data, id, role, token, idFacebookMessenger, urlBack, tipoCanal) {
    console.log(`${urlBack}/sendCompleto/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=0&tipoCanal=${tipoCanal}`);
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //return this.http.post(`${url}send.php/`, data);
    return this.http.post(`${urlBack}/sendCompleto/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=0&tipoCanal=${tipoCanal}`, data, { headers });
  }

  enviarMensajeMuro(data, id, role, token, idFacebookMessenger, idMuro, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //return this.http.post(`${url}send.php/`, data);
    return this.http.post(`${urlBack}/sendCompleto/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=${idMuro}&tipoCanal=2`, data, { headers });
  }

  eventoCerradoSesion() {

    return this.wsService.listen('cerrar-sesion-agente');
  }


  guardarNuevoChat(mensjeObj, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/planIt/newMessage/${id}/${role}`, mensjeObj, { headers });
  }

  consultarIdNumero(idAdmin, idAgente, numero) {
    return this.http.get(`${this.url}/planIt/getId/${idAdmin}/${idAgente}/${numero}`);
  }

  getMessages() {
    return this.wsService.listen('mensaje-nuevo');
  }

  getMessagesPrivate() {

    return this.wsService.listen('mensaje-privado');
  }

  getAlertaCampana() {
    return this.wsService.listen('alerta-campana');
  }

  getStatusUpdateChat() {
    return this.wsService.listen('update-status');
  }

  getUpdateDashboard() {
    return this.wsService.listen('update-dashboard');
  }

  getUpdateSemaforo() {
    return this.wsService.listen('alerta-semaforo');
  }

  getTipificacion() {
    return this.wsService.listen('alerta-resultado');
  }


  enviarMensajePrivadoAgente(idSocket, mensaje) {
    return this.http.post(`${this.urlWs}enviarMensajeAgente/${idSocket}`, mensaje);
  }

  enviarMensajePrivadoSemaforo(idSocket, mensaje) {
    return this.http.post(`${this.urlWs}alertaSemaforo/${idSocket}`, mensaje);
  }


  //conversaciones de agente
  getConversacionesDeNumero(idAdmin, idAgente, idNumero, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getChat/${idAdmin}/${idAgente}/${idNumero}/${id}/${role}`, { headers });

  }

  //conversaciones de agente versión optimizada

  getConversacionesNumeroOptimizado(idAdmin, idAgente, idNumero, id, role, token, conv, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getChatConver/${idAdmin}/${idAgente}/${idNumero}/${conv}/${id}/${role}`, { headers });

  }



  //conversaciones de admin
  getNumerosAdmin(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getNumerosAdmin/${idAdmin}/${id}/${role}`, { headers });
  }

  ///api para acutalizar que el numero asignado al agente tiene un nuevo mensaje
  mensajeNuevoCliente(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarNumeroNuevoAgente/${id}/${role}`, data, { headers });
  }

  mensajeNuevoClienteMessengerFacebok(data, id, role, token, idFacebookMessenger, urlBack, tipoCanal) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarNumeroNuevoAgente/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=0&tipoCanal=${tipoCanal}`, data, { headers });
  }

  mensajeNuevoClienteMuro(data, id, role, token, idFacebookMessenger, idMuro, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarNumeroNuevoAgente/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=${idMuro}&tipoCanal=2`, data, { headers });
  }


  finalizarChat(data, numero, idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/planIt/updateNum/${numero}/${idAdmin}/${id}/${role}`, data, { headers });
  }

  bloquearNum(data, numero, idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/bloquearNum/${numero}/${idAdmin}/${id}/${role}`, data, { headers });
  }

  //actualizar estatus del numero para que reciba calificación del agente

  updateStatusNumero(idAdmin, data, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${this.url}/switch-bot/${idAdmin}/${id}/${role}`, data, { headers });
  }

  //crea el registro para la calificacion de agente

  agregarCalifAgente(data, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${this.url}/agregarCalifAgente/${id}/${role}`, data, { headers });
  }

  uploadImgPlan(nombre, id, url, data) {
    return this.http.post(`${url}uploadImagen/${nombre}/${id}`, data);
  }

  getImgPlan(nombre, url) {
    return this.http.get(`${url}getImagen/${nombre}/`);
  }

  consultarRespuestasRapidas(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtenerRespuestaRapida/${idAdmin}/${id}/${role}`, { headers });

  }

  //------- Asignación pendiente en cierre de sesion -----
  asignacionPendienteCierreSesion(idAdmin, idAgente, id, role, token, urlBack) {
    console.log(idAdmin, idAgente, id, role, token);
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/asignacionPendienteCierreSesion/${idAdmin}/${idAgente}/${id}/${role}`, { headers });

  }

  getListaEstatus(idAdmin, id, role, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtenerListaEstatus/${idAdmin}/${id}/${role}?${query}`, { headers });
  }

  getUrlAdmin(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //console.log(idAdmin, id, role, token, urlBack)
    return this.http.get(`${urlBack}/obtenerUrl/${idAdmin}/${id}/${role}`, { headers });
  }

  getPromRes(idAdmin, idCamp, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/masivos/promedioResp/${idAdmin}/${idCamp}/${id}/${role}`, { headers });
  }

  //storage aws
  uploadArchivo(data, id) {
    // console.log(data, id, 'service')
    return this.http.post(`${this.urlStorage}upload/planitwhatsapp/${id}`, data);
  }

  //storage multimedia por canal
  uploadArchivoMeta(data, url, id, rol, token) {
    // console.log(data, id, 'service')
    return this.http.post(`${url}subirArchivoMeta/${id}/${rol}/${token}`, data);
  }

  //Registro de nueva plantlla
  registroPlantillaMeta(data, url, id, rol, token) {
    // console.log(data, id, 'service')
    return this.http.post(`${url}crearPlantilla/${id}/${rol}/${token}`, data);
  }

  //delete aws
  deletAwsArchivo(id) {
    return this.http.delete(`${this.urlStorage}delete-object/planitwhatsapp/${id}`);
  }

  //servidor que aloja el canal de whatsapp
  uploadArchivoServer(url, data, numero, tipo, id, role, token, caption) {
    return this.http.post(`${url}upload/${numero}/${tipo}/${id}/${role}/${token}/${caption}`, data);
  }


  //servidor que aloja el canal de FacebookMessenger
  uploadArchivoServerFacebookMessenger(url, data, numero, tipo, id, role, token) {
    return this.http.post(`${url}upload/${numero}/${tipo}/${id}/${role}/${token}`, data);
  }

   //servidor que aloja el canal de FacebookMessenger
  uploadArchivoServerInstagram(url, data, numero, tipo, id, role, token) {
    return this.http.post(`${url}uploadInstagram/${numero}/${tipo}/${id}/${role}/${token}`, data);
  }


  //registro de datos del cliente

  guardarRegistroCliente(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/agregarRegCliente/${id}/${role}`, data, { headers });
  }

  //consulta registro del cliente
  getRegistroCliente(idNumero, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getRegCliente/${idNumero}/${id}/${role}`, { headers });
  }


  // consulta registro de cliente version 2
  getResultadoChat(idAdmin, conv, idNumero, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getResultadoChat/${idAdmin}/${conv}/${idNumero}/${id}/${role}`, { headers });
  }

  // consulta Estados de agente
  getEstadosAgente(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getEstadoAgente/${idAdmin}/${id}/${role}`, { headers });
  }


  //actualizacion de datos cliente

  actualizarRegistroCliente(data, idNumero, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/updateRegCliente/${idNumero}/${id}/${role}`, data, { headers });
  }


  //guardar notas y status en chats

  guardarNotaStatus(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/updateNotaStatus/${id}/${role}`, data, { headers });
  }


  enviarPlantilla(url, data, id, role, token, urlBack) {
    data.url = url;
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/sendPlantilla/${id}/${role}`, data, { headers });
  }

  registrarEnvioPlantilla(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //return this.http.post(`${this.url}/registrarEnvioPlantilla/${id}/${role}`, data, {headers});
    return this.http.post(`${urlBack}/registrarEnvioPlantilla`, data);
  }

  consultarPlantillas(idAdmin, id, rol, token, masivos, individual, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtener-plantillas/${idAdmin}/${id}/${rol}?ad_planit=true&status=1&masivos=${masivos}&individual=${individual}`, { headers });
  }

  consultarPlantilla(idAdmin, nombre_whatsapp, id, rol, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getPlantilla/${idAdmin}/${nombre_whatsapp}/${id}/${rol}?ad_planit=true`, { headers });
  }

  consultarAsignacionPendiente(idAdmin, idAgente, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/asigPendNumero/${idAdmin}/${idAgente}/${id}/${role}?sucursal=1`, { headers });
  }

  consultarOrigenes(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getOrigenes/${id}/${role}?admin=${idAdmin}`, { headers });
  }

  consultarNombresForms(idAdmin, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/consultarNombresForms/${id}/${role}?admin=${idAdmin}`, { headers });
  }

  consultarIdsForms(idAdmin, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/consultarIdForms/${id}/${role}?admin=${idAdmin}`, { headers });
  }

  consultarGraficaConver(idAdmin, id, role, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/graficaBarrasConver/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  consultarGraficaConverMAsivos(idAdmin, id, role, token, query) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.urlMasivos}/graficaBarrasConver/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  getMetricasNum(idAdmin, id, role, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/metricasNum/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  getPlantillasDashboard(idAdmin, id, role, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/dashboardPlantillas/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  getPlantillasDashboardMasivos(idAdmin, id, role, token, query) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.urlMasivos}/dashboardPlantillas/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  getTasasConver(idAdmin, id, role, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/tasasConver/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  getTasasConverMasivos(idAdmin, id, role, token, query) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.urlMasivos}/tasasConver/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  consultarGraficaResultado(idAdmin, id, role, token, query, data, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/graficaResultados/${idAdmin}/${id}/${role}${query}`, data, { headers });
  }

  consultarGraficaResultadosAgentes(idAdmin, id, role, token, query, data, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/graficaResultadosAgentes/${idAdmin}/${id}/${role}${query}`, data, { headers });
  }

  consultarGraficaOrigen(idAdmin, id, role, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/graficaOrigen/${idAdmin}/${id}/${role}${query}`, { headers });
  }

  asigacionAgente(idAdmin, data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //consultarAsignacionAgente/:idAdmin
    return this.http.post(`${urlBack}/planIt/consultarAsignacionAgente/${idAdmin}/${id}/${role}`, data, { headers });
  }

  consultarSockets(idAdmin, data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/planIt/consultarIdSocketAgente/${idAdmin}/${id}/${role}`, data, { headers });
  }

  consultarSocketsAgente(idAdmin, idAgente, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/planIt/consultarIdSocketAgenteCanal/${idAgente}/${idAdmin}/${id}/${role}`);
  }

  addPlantilla(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/guardar-plantilla/${id}/${role}?ad_planIt=true`, data, { headers });
  }

  consultaPlantillas(idAdmin, id, role, token, masivos, individual, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtener-plantillas/${idAdmin}/${id}/${role}?ad_planIt=true&masivos=${masivos}&individual=${individual}`, { headers });
  }

  consultaPlantillasStatus(idAdmin, id, role, token, status, masivos, individual, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtener-plantillas/${idAdmin}/${id}/${role}?ad_planIt=true&status=${status}&masivos=${masivos}&individual=${individual}`, { headers });
  }

  consultaPlantillasStatusfiltro(idAdmin, id, role, token, status, filtro, masivos, individual, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtener-plantillas/${idAdmin}/${id}/${role}?ad_planIt=true&status=${status}&masivos=${masivos}&individual=${individual}${filtro}`, { headers });
  }

  consultaSaldoSms(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    if (idAdmin == 40) {
      return this.http.get(`${this.urlMasivos}/consultaSaldoRegSms/${idAdmin}/${id}/${role}?ad_planIt=true`, { headers });
    } else {
      return this.http.get(`${urlBack}/consultaSaldoRegSms/${idAdmin}/${id}/${role}?ad_planIt=true`, { headers });
    }

  }

  upload(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    // console.log(data.get('idAdmin'), 'data en service');
    if (data.get('idAdmin') == 40) {
      return this.http.post(`${this.urlMasivos}/uploadCsv/${id}/${role}?ad_planIt=true&nomCamp=1`, data, { headers });
    } else {
      return this.http.post(`${urlBack}/planit/uploadCsv/${id}/${role}?ad_planIt=true&nomCamp=1`, data, { headers });
    }

  }

  // ----  Carga de Archivos Cyse ----
  uploadCyse(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/uploadCyse/${id}/${role}?ad_planIt=true`, data, { headers });
  }

  generarMasivo(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);

    console.log('generarMasivo desde el servicio', data, id, role, token, urlBack)
    if (data.idAdmin == 40) {
      return this.http.post(`${this.urlMasivos}/generarMasivo/${id}/${role}?ad_planIt=true`, data, { headers });
    } else {
      return this.http.post(`${urlBack}/generarMasivo/${id}/${role}?ad_planIt=true`, data, { headers });
      // return this.http.post(`${urlBack}/startCamping/${id}/${role}?ad_planIt=true`, data, { headers });
    }
  }

  ProgramarMasivo(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    if (data.idAdmin == 40) {
      return this.http.post(`${this.urlMasivos}/campProgramada/${id}/${role}?ad_planIt=true`, data, { headers });
    } else {
      return this.http.post(`${urlBack}/campProgramada/${id}/${role}?ad_planIt=true`, data, { headers });
    }
  }

  saldoDisponible(idadmin, data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);

    if (idadmin == 40) {
      return this.http.post(`${this.urlMasivos}/disponibilidadMasivos/${idadmin}/${id}/${role}`, data, { headers });
    } else {
      return this.http.post(`${urlBack}/disponibilidadMasivos/${idadmin}/${id}/${role}`, data, { headers });
    }

  }


  // RE ASIGNACION DE AGENTE
  updatedatosNumero(idadmin, from, data, id, role, token, evento, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/planIt/updateNum/${from}/${idadmin}/${id}/${role}?evento=${evento}${query}`, data, { headers });

  }


  // RE ASIGNACION DE SUCURSAL
  reAsignarSucursal(idadmin, from, sucursal, id, role, token, query, url_back) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(
      `${url_back}/planIt/asignacionAgente/${idadmin}/${from}/${id}/${role}?&sucursal=${sucursal}&asigSuc=1&agenteAntAsig=${id}${query}`, {
      headers
    });

  }


  //validacion Agente activo o no
  pendienteEnvioInd(idadmin, from, idAgente, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/planIt/pendienteEnvioInd/${idadmin}/${from}/${idAgente}/${id}/${role}`, { headers });

  }

  //notificar web push

  notificacionPush(agenteAsignado, idAdmin, id, role, token, data) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${this.url}/planIt/sendNotPush/${agenteAsignado}/${idAdmin}/${id}/${role}`, data, { headers });

  }

  // Carga de clientes
  cargaClientes(idAdmin, id, role, token, data, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/cargaClientes/${idAdmin}/${id}/${role}`, data, { headers });

  }


  //consultar reportes disponibles para descarga

  consultaReportesDisponibles(idAdmin, urlBack) {
    // const headers = new HttpHeaders()
    // .set('rol-token', token);
    return this.http.get(`${urlBack}/consultarReportesDisponibles/${idAdmin}`);
  }

  finalizarChatGeneral(idAdmin, idAgente, idWhats, numeroWhats, id, role, token, data, urlBack) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/finalizarChat/${idAdmin}/${idAgente}/${idWhats}/${numeroWhats}/${id}/${role}`, data, { headers });
    //finalizarChat/:idAdmin/:idAgente/:idCliente/:numero/:id/:role
  }

  finalizarChatGeneralMessengerFaebook(idAdmin, idAgente, idWhats, numeroWhats, id, role, token, data, urlBack, tipoCanal) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/finalizarChat/${idAdmin}/${idAgente}/${idWhats}/0/${id}/${role}?idFacebookMessenger=${numeroWhats}&idMuro=0&tipoCanal=${tipoCanal}`, data, { headers });
    //finalizarChat/:idAdmin/:idAgente/:idCliente/:numero/:id/:role
  }

  finalizarChatGeneralMuro(idAdmin, idAgente, idWhats, numeroWhats, id, role, token, data, urlBack) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/finalizarChat/${idAdmin}/${idAgente}/${idWhats}/0/${id}/${role}?idFacebookMessenger=${numeroWhats}&idMuro=0&tipoCanal=2`, data, { headers });
    //finalizarChat/:idAdmin/:idAgente/:idCliente/:numero/:id/:role
  }


  consultarHistorialChats(idAgente, rol, idAdmin, token) {
    const data = {};
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${this.url}/consultaNumHistoricos/${idAgente}/${rol}?admin=${idAdmin}&agente=${idAgente}`, data, { headers });

  }


  consultarStatusNumeros(idAdmin, id, rol, token, data, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/planIt/consultaStatus/${idAdmin}/${id}/${rol}?${query}`, data, { headers });

  }

  consulta24hrs(idAdmin, idCliente, conversacion, id, rol, token, urlBack) {
    //consulaChat24hrs/:idCliente/:idAdmin/:conversacion/:id/:role
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/consulaChat24hrs/${idCliente}/${idAdmin}/${conversacion}/${id}/${rol}`, { headers });
  }

  consultarNumeroIndividual(numero, idAdmin, id, rol, token, query, urlBack) {
    //getNumeroBypk/:numero/:idAdmin/:id/:role}
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getNumeroBypk/${numero}/${idAdmin}/${id}/${rol}?${query}`, { headers });
  }

  envioRecetario(archivo) {
    //getNumeroBypk/:numero/:idAdmin/:id/:role}
    const headers = new HttpHeaders();
    // .set('rol-token', token);
    return this.http.post(`${this.url}/envioRecetario/`, archivo, { headers });
  }

  validacionEnvioPlantilla(numero, idAdmin, id, rol, token, urlBack) {
    //getNumeroBypk/:numero/:idAdmin/:id/:role}
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/validacionSendPlantilla/${idAdmin}/${numero}/${id}/${rol}`, { headers });
  }


  consultarCodigosPais(idAdmin, id, rol, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/obtenerCodigosPais/`, { headers });
  }

  obtenerResultadoChat(idAdmin, conversacion, idCliente, id, rol, token, urlBack) {
    //getNumeroBypk/:numero/:idAdmin/:id/:role}
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getResultadoChat/${idAdmin}/${conversacion}/${idCliente}/${id}/${rol}`, { headers });
    //getResultadoChat/:idAdmin/:conversacion/:idCliente/:id/:role
  }

  // ---- Update plantilla -------
  updatePlantilla(data, idPlantilla, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    console.log(data, idPlantilla, id, role, token)
    return this.http.put(`${urlBack}/actualizar-plantilla/${idPlantilla}/${id}/${role}`, data, { headers });
  }


  getSemaforoAgentes(idAgente, idAdmin, id, rol, token, global) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/getNumAgenteSemaforo/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}`, { headers });
    //getNumAgenteSemaforo/:idAgente/:idAdmin/:id/:role?global=1
  }


  getNumerosSinAsignar(idAdmin, id, rol, token, urlBack) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getNumerosNoAsignados/${idAdmin}/${id}/${rol}`, { headers });
    //getNumerosNoAsignados/:idAdmin/:id/:role
  }


  asignacionAutomatica(idAdmin, id, rol, token) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/distribucionPendiente/${idAdmin}/${id}/${rol}`, { headers });
    //distribucionPendiente/:idAdmin/:id/:role
  }

  getultimoChat(idAdmin, idWhatsapp, id, rol, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getChatXconver/${idAdmin}/${idWhatsapp}/${id}/${rol}`, { headers });
    //getChatXconver/:idAdmin/:idCliente/:id/:role
  }


  //consultaChatXConver/:idNumero/:conver/:id/:role
  //consultaChatXConver
  getconversacionHistoricoChatResultado(idAdmin, idWhatsapp, conv, id, rol, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/consultaChatXConver/${idWhatsapp}/${conv}/${id}/${rol}`, { headers });

    //consultaChatXConver/:idNumero/:conver/:id/:role
  }

  getHisorialChatsResultado(idWhatsapp, id, rol, token, urlBack) {
    //listaChatXResulatdos/:idNumero/:id/:role
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/listaChatXResulatdos/${idWhatsapp}/${id}/${rol}`, { headers });

  }

  //historial de chats cerrados para admins:

  getHistorialChatsCerradosAdmin(idAdmin, cantidad, numero, id, rol, token, urlBack, tipificacion?) {
    // getNumHistoricosPaginado/:id/:role?admin=8&paginacion=40&numero=52156
    const headers = new HttpHeaders()
      .set('rol-token', token);

    if (tipificacion === undefined || tipificacion === 'Todos') {
      return this.http.get(`${urlBack}/getNumHistoricosPaginado/${id}/${rol}?admin=${idAdmin}&paginacion=${cantidad}&numero=${numero}`, { headers });
    } else {
      return this.http.get(`${urlBack}/getNumHistoricosPaginado/${id}/${rol}?admin=${idAdmin}&paginacion=${cantidad}&numero=${numero}&tipificacion=${tipificacion}`, { headers });
    }
  }

  getHistorialChatsCerradosAgente(idAdmin, cantidad, numero, agente, id, rol, token, urlBack, tipificacion?) {
    // getNumHistoricosPaginado/:id/:role?admin=8&paginacion=40&numero=52156
    const headers = new HttpHeaders()
      .set('rol-token', token);

    if (tipificacion === undefined || tipificacion === 'Todos') {
      return this.http.get(`${urlBack}/getNumHistoricosPaginado/${id}/${rol}?admin=${idAdmin}&agente=${agente}&paginacion=${cantidad}&numero=${numero}`, { headers });
    } else {
      return this.http.get(`${urlBack}/getNumHistoricosPaginado/${id}/${rol}?admin=${idAdmin}&agente=${agente}&paginacion=${cantidad}&numero=${numero}&tipificacion=${tipificacion}`, { headers });
    }
  }

  // nueva versión de semaforos

  //atendidos
  getSemaforoAgentesAten(idAgente, idAdmin, id, rol, token, global, urlBack, tipificacion?) {
    //getNumagenteSemaforoAten/:idAgente/:idAdmin/:id/:role
    const headers = new HttpHeaders()
      .set('rol-token', token);

    if (tipificacion === undefined || tipificacion === 'Todos') {
      return this.http.get(`${urlBack}/getNumagenteSemaforoAten/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}`, { headers });
    } else {
      return this.http.get(`${urlBack}/getNumagenteSemaforoAten/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}&tipificacion=${tipificacion}`, { headers });
    }
  }

  // sin respuesta
  //getNumagenteSemaforoNoRes/:idAgente/:idAdmin/:id/:role

  getSemaforoAgentesSinRes(idAgente, idAdmin, id, rol, token, global, urlBack, tipificacion?) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    if (tipificacion === undefined || tipificacion === 'Todos') {
      return this.http.get(`${urlBack}/getNumagenteSemaforoNoRes/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}`, { headers });
    } else {
      return this.http.get(`${urlBack}/getNumagenteSemaforoNoRes/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}&tipificacion=${tipificacion}`, { headers });
    }
  }

  //no atendidos
  getSemaforoAgentesNoAtend(idAgente, idAdmin, id, rol, token, global, urlBack, tipificacion?) {
    //getNumagenteSemaforoNoAten/:idAgente/:idAdmin/:id/:role
    const headers = new HttpHeaders()
      .set('rol-token', token);
    if (tipificacion === undefined || tipificacion === 'Todos') {
      return this.http.get(`${urlBack}/getNumagenteSemaforoNoAten/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}`, { headers });
    } else {
      return this.http.get(`${urlBack}/getNumagenteSemaforoNoAten/${idAgente}/${idAdmin}/${id}/${rol}?global=${global}&tipificacion=${tipificacion}`, { headers });
    }
  }

  consultarConteoOpenIa(idAdmin, id, rol, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/consultarConteoOpenIa/${idAdmin}/`, { headers });
  }

  actualizarConteoOpenIa(idAdmin, id, rol, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarConteoOpenIa/${idAdmin}/`, {}, { headers });

  }

  /*
  consultarTexto(): Observable<any> {
    const url = this.urlConsultaTexto;

    const requestOptions = {
        method: 'POST',
    };

    return new Observable<any>(observer => {
        fetch(url, requestOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error en la solicitud');
                }
                return response.json();
            })
            .then(data => {

                console.log(data);
                observer.next(data);
                observer.complete();
            })
            .catch(error => {
                console.error('Error al consultar la API:', error);
                observer.error(error);
            });
    });
  }*/

  generarImagenes(data) {
    const headers = new HttpHeaders();
    //return this.http.post(`$this.url}`, data);
    return this.http.post(`${this.urlConsultaTexto}crear-imagen`, data, { headers });
  }

  consultarTexto(data) {
    const headers = new HttpHeaders();
    //return this.http.post(`$this.url}`, data);
    return this.http.post(`${this.urlConsultaTexto}consultaTexto`, data, { headers });
  }

  consultarTextoPlantillasIa(data) {
    const headers = new HttpHeaders();
    //return this.http.post(`$this.url}`, data);
    return this.http.post(`${this.urlConsultaTexto}consultaTextoPlantillas`, data, { headers });
  }

  getCalidadIA(data) {
    const headers = new HttpHeaders();
    //return this.http.post(`$this.url}`, data);
    return this.http.post(`${this.urlConsultaTexto}saludoDespedida`, data, { headers });
  }

  contactos(idAdmin, id, role, token, query, paginacion, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getClientes/${idAdmin}/${id}/${role}?paginacion=${paginacion}${query}`, { headers });
  }

  creacionCategorias(idAdmin, id, role, token, nombre, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    const body = {
      nombre: nombre
    };
    return this.http.post(`${urlBack}/registroCategoria/${idAdmin}/${id}/${role}`, body, { headers });
  }


  registrarCategoria(idAdmin, id, role, token, nombre, urlBack) {
    if (!token) {
      throw new Error('El token es obligatorio y no puede estar vacío.');
    }
    const headers = new HttpHeaders({
      'rol-token': token
    });
    const body = { nombre };
    return this.http.post(`${urlBack}/registroCategoria/${idAdmin}/${id}/${role}`, body, { headers });
  }

  consultarCategorias(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getCategorias/${idAdmin}/${id}/${role}`, { headers });
  }

  actualizarCategoria(idPlantilla, id, role, token, data, urlBack) {
    const headers = new HttpHeaders().set('rol-token', token);
    const url = `${urlBack}/actualizar-plantilla/${idPlantilla}/${id}/${role}`;
    return this.http.put(url, data, { headers });
  }

  /*
  consultarCp(cp, id, role, token){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    const url = `${this.url}/getCiudadesCp/${cp}/${id}/${role}`;
    return this.http.get(url, cp, { headers });
  }*/

  consultarCp(cp, id, role, token, urlBack) {
    const headers = new HttpHeaders().set('rol-token', token);
    const apiUrl = `${urlBack}/getCiudadesCp/${cp}/${id}/${role}`;
    return this.http.get(apiUrl, { headers });
  }

  consultarMunicipio(estado, id, role, token, urlBack) {
    const headers = new HttpHeaders().set('rol-token', token);
    const apiUrl = `${urlBack}/getMunicipios/${estado}/${id}/${role}`;
    return this.http.get(apiUrl, { headers });
  }

  consultarAsentamiento(municipio, id, role, token, urlBack) {
    const headers = new HttpHeaders().set('rol-token', token);
    const apiUrl = `${urlBack}/getAsentamientos/${municipio}/${id}/${role}`;
    return this.http.get(apiUrl, { headers });
  }

  eliminarPlantilla(idAdmin, idPlantilla, id, role, token, urlBack) {
    const headers = new HttpHeaders().set('rol-token', token);
    const apiUrl = `${urlBack}/consultaStatusPlantilla/${idAdmin}/${idPlantilla}/${id}/${role}`;
    return this.http.get(apiUrl, { headers });
  }

  nombreExistente(idAdmin, nombre, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/existPlantilla/${idAdmin}/${nombre}/${id}/${role}`, { headers });
  }

  eliminarPlantillaSistema(idPlantilla, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.delete(`${urlBack}/deletePlantilla/${idPlantilla}/${id}/${role}`, { headers });
  }

  /*
  deletePlantilla(urlCanal, nombrePlantilla, id, rol, token){
    const url = `${urlCanal}eliminarPlantillas/${nombrePlantilla}/${id}/${rol}`;
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.delete(url, { headers });
    console.log(url)
  }*/

  deletePlantilla(urlCanal, nombrePlantilla, id, rol, token) {
    const url = `${urlCanal}eliminarPlantillas/${nombrePlantilla}/${id}/${rol}/${token}`;
    return this.http.delete(url);
    console.log(url);
  }

  generarIdEncuesta(id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/generarIdEncuesta/${id}/${role}`, { headers });
  }

  guardarIdResp(idAdmin, idPregunta, idRespuesta, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/updateIdResp/${idAdmin}/${idPregunta}/${idRespuesta}/${id}/${role}`, { headers });
  }

  guardarPregunta(idAdmin, id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/vabbel/encuestas/createPregunta/${idAdmin}/${id}/${role}`, body, { headers });
  }

  guardarAccionEncuestas(idAdmin, id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
      console.log(body, 'body en service operador');
    return this.http.post(`${urlBack}/encuestas/createAcciones/${idAdmin}/${id}/${role}`, body, { headers });
  }

  actualizarEncuesta(idPregunta, idAdmin, id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/vabbel/encuestas/updatePregunta/${idPregunta}/${idAdmin}/${id}/${role}`, body, { headers });
  }

  guardarTipo(id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/guardarTipoPregunta/${id}/${role}`, body, { headers });
  }

  consultarCategoriasAcciones(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/getGrupos/${idAdmin}/${id}/${role}`, { headers });
  }

  crearNuevaCategoria(idAdmin, id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/encuestas/createGrupos/${idAdmin}/${id}/${role}`, body, { headers });
  }

  actualizarFotoPerfil(idAdmin, idAgente, id, role, token, data) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${this.url}/updateAgente/${idAdmin}/${idAgente}/${id}/${role}`, data, { headers });
  }

  getFotoPerfil(idAdmin, idAgente, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/fotoPerfilagente/${idAdmin}/${idAgente}/${id}/${role}`, { headers });
  }

  editarPlantilla(urlCanal, id, rol, token, data2) {
    const urlEditar = `${urlCanal}editarPlantilla/${id}/${rol}/${token}`;
    const headers = new HttpHeaders();
    console.log(urlCanal, data2, 'servicio consu', token);
    return this.http.post(urlEditar, data2, { headers });
  }

  enviarDatosLoginDinamico(data, idAdmin, id, role, token) {
    console.log(data, idAdmin, id, role, token);
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${this.url}/updateBlog/${idAdmin}/${id}/${role}`, data, { headers });
  }

  consultaLoginDinamico(idAdmin) {
    const headers = new HttpHeaders();
    return this.http.get(`https://backVabbel.planitondemand.com.mx/api/blog/${idAdmin}`, { headers });
  }

  consultarConversaciones(urlCanal, inicio, fin, token, granularidad) {
    const urlConsulta = `${urlCanal}consultarConversaciones/${inicio}/${fin}/${granularidad}`;
    const headers = new HttpHeaders();
    //console.log(urlCanal,inicio, fin, token, granularidad);
    return this.http.get(urlConsulta, { headers });
  }

  consultarPregutas(idAdmin, idEncuesta, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/getPreguntas/${idEncuesta}/${idAdmin}/${id}/${role}`, { headers });
  }

  cambiarBoton(idTipo, idAdmin, id, role, token, urlBack, body) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    console.log(idTipo, idAdmin, id, role, token, urlBack, body);
    return this.http.put(`${urlBack}/encuestas/updateTipoResp/${idTipo}/${idAdmin}/${id}/${role}`, body, { headers });
  }

  consultarAcciones(idAdmin, idTipoResp, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/encuestas/getAccion/${idAdmin}/${idTipoResp}/${id}/${role}`, { headers });
  }

  getConverConcat(idAdmin, idNumero, conversacion, id, role, token, urlBack) {
    const headers = new HttpHeaders().set('rol-token', token);
    return this.http.get(`${urlBack}/getConverConcat/${idAdmin}/${idNumero}/${conversacion}/${id}/${role}`, { headers });
  }

  validResults(data) {
    const headers = new HttpHeaders();
    return this.http.post(`${this.urlConsultaTexto}validar-resultado-chat`, data, { headers });
  }

  updateTipoResp(data, idTipoResp, idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    const url = `${urlBack}/updateTipoResp/${idTipoResp}/${idAdmin}/${id}/${role}`;
    return this.http.put(url, data, { headers });
  }

  getInfoConfig(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    const url = `${urlBack}/getInfoConfig/${idAdmin}/${id}/${role}`;
    return this.http.get(url, { headers });
  }

  updateConfig(idAdmin, id, role, token, urlBack, body){
    const headers = new HttpHeaders()
      .set('rol-token', token);
    const url = `${urlBack}/updateConfig/${idAdmin}/${id}/${role}`;
    return this.http.put(url, body, { headers });
  }

registrarLogConfig(urlCanal, idAdmin, id, role, token, logData) {
    const headers = new HttpHeaders()
        .set('rol-token', token); 
    const url = `${urlCanal}/logsRegconf/${idAdmin}/${id}/${role}`;
    return this.http.post(url, logData, { headers });
  }
}
